
import React from "react";
import {
  Control,
  Controller,
  useController,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import SelectBox from "@/components/Form/SelectBox/SelectBox";
import { NonEmptyString } from "@/utility/common";
import { MotifErrorMessage } from "@ey-xd/motif-react";

type ControlSelectType = {
  required?: boolean;
  isTextArea?: boolean;
  control: Control<any>;
  name: string;
  showLabel: boolean;
  label: string;
  options: {
    label: string;
    value: any;
  }[];
  value?: string | number;
  disabled?: boolean;
  multiple?: boolean;
  filter?:boolean;
  governmentIDKey:string,
  fieldArrayIndex:number,
  fieldArrayKey:string,
};

export default function PrivacySelectDropDown({
  name,
  control,
  required = false,
  options,
  showLabel,
  label,
  value,
  disabled,
  multiple,
  filter,
  governmentIDKey,
fieldArrayIndex,
fieldArrayKey,

}: ControlSelectType) {
  const {formState } = useController({
    //@ts-ignore
    name,
    control,
    rules: { required: required },
  }); 
  const {field } = useController({
    //@ts-ignore
    name:governmentIDKey,
    control,
  }); 
  const { t } = useTranslation();
  if (options === undefined) {
    return null;
  }
 
      required=field?.value?true:false
      let errors :any =formState.errors; 
  const translatedOptions =
    options &&
    options.map((option) => {
      return {
        label: option.label,
        value: option.value,
      };
    });

  const defaultValue = NonEmptyString(value?.toString()) ? value : options[0]?.value;
  return (
    <>
      {showLabel && (
        <div className="formFieldLabel">
          <label htmlFor="input" aria-label={label}>
            {t(label)}
            {required ? <span className="requiredSymbol">*</span> : ""}
          </label>
        </div>
      )}
      <Controller
        // @ts-ignore
        name={name}
        control={control}
        rules={{ required }}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <SelectBox
                options={translatedOptions}
                value={value}
                onChange={onChange}
                disabled={disabled}
                multiple={multiple}
                filter={filter}
              />
              {errors && errors?.fieldArray && errors?.fieldArray?.[fieldArrayIndex]?.[fieldArrayKey]?.type==="required" && <MotifErrorMessage>{t("pages.creditors.creditorForm.formLabelDetails.requiredFieldsMessages.documnetIdRequired",{filedName:t(label)})}</MotifErrorMessage>}
              
            </>
          );
        }}
      />
    </>
  );
}
